import { useEffect, useRef } from "react";
import styles from "./gradientBackground.module.css";

export default function GradientBackground() {
  const cursorBlob = useRef(null);

  useEffect(() => {
    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let currentX = targetX;
    let currentY = targetY;
    let rafId;

    const onMove = (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
    };

    const animate = () => {
      // Плавное следование за курсором (lerp)
      currentX += (targetX - currentX) * 0.07;
      currentY += (targetY - currentY) * 0.07;

      if (cursorBlob.current) {
        cursorBlob.current.style.transform =
          `translate(${currentX}px, ${currentY}px) translate(-50%, -50%)`;
      }

      rafId = requestAnimationFrame(animate);
    };

    window.addEventListener("pointermove", onMove);
    rafId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("pointermove", onMove);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div className={styles.bg}>
      <div className={`${styles.blob} ${styles.blob1}`} />
      <div className={`${styles.blob} ${styles.blob2}`} />
      <div className={`${styles.blob} ${styles.blob3}`} />
      <div className={`${styles.blob} ${styles.blob4}`} />
      <div ref={cursorBlob} className={`${styles.blob} ${styles.cursorBlob}`} />
      <div className={styles.grid} />
      <div className={styles.vignette} />
    </div>
  );
}
